module.exports = __webpack_public_path__ + "img/text.28689a03.png";